import DescriptionBookCreateEdit from "./components/DescriptionBookCreateEdit";
import Cover from "./components/Cover";
import Descriptions from "./components/Description/Descriptions";
import Settings from "./components/SettingsFields/Index";
import AcquisitionBatchCreateEdit from "./components/AcquisitionBatch/AcquisitionBatchCreateEdit";
import WriteOffSetCreateEdit from "./components/WriteOffSet/WriteOffSetCreateEdit";
import TransferCreateEdit from "./components/Transfer/TransferCreateEdit";
import InventoryCreateEdit from "./components/Reports/InventoryCreateEdit";
import BookReports from "./components/Reports/BookReports";
import AudioEditor from "./components/AudioBookEdit";
import AudioBookIndex from "./components/AudioBookIndex";

export default {
    mode: 'history',
    routes:[
        { path: '/descriptions', name: 'descriptions',component: Descriptions },
        { path: '/audio-books/:id', name: 'AudioBookIndex',component: AudioBookIndex },
        { path: '/audio-books/:id/edit/:chapterId', name: 'AudioEditor',component: AudioEditor },
        { path: '/library/books/create', name: 'descriptionCreate',component: DescriptionBookCreateEdit },
        { path: '/library/descriptions/:id/edit', name: 'descriptionEdit',component: DescriptionBookCreateEdit },
        { path: '/library/cover', name: 'cover',component: Cover },
        { path: '/library/settings', name: 'settings',component: Settings },
        { path: '/library/acquisition-batches/create', name: 'acquisitionBatchesCreate',component: AcquisitionBatchCreateEdit },
        { path: '/library/acquisition-batches/:id/edit', name: 'acquisitionBatchEdit',component: AcquisitionBatchCreateEdit },
        { path: '/library/write-off-sets/create', name: 'writeOffSetCreate',component: WriteOffSetCreateEdit },
        { path: '/library/write-off-sets/:id/edit', name: 'writeOffSetEdit',component: WriteOffSetCreateEdit },
        { path: '/library/transfers/create', name: 'TransferCreate',component: TransferCreateEdit },
        { path: '/library/transfers/:id/edit', name: 'TransferEdit',component: TransferCreateEdit },
        { path: '/library/reports/inventory/create', name: 'InventoryCreate',component: InventoryCreateEdit },
        { path: '/library/reports/inventory/:id/edit', name: 'InventoryEdit',component: InventoryCreateEdit },
        { path: '/library/book-reports', name: 'BookReports',component: BookReports },
    ]
}

